import React from "react";
import "./MaatwerkFooter.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import cytLogo from "../../img/cyt-logo.png";
import vwcLogo from "../../img/vwc-logo.png";
import { useTranslation } from "react-i18next";
import LaunchIcon from "@mui/icons-material/Launch";

const MaatwerkFooter = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  // Media queries
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const tablet = useMediaQuery(theme.breakpoints.between("ipad", "laptop"));
  const laptop = useMediaQuery(theme.breakpoints.up("laptop"));

  return (
    <React.Fragment>
      {/* MOBILE */}
      {mobile && (
        <div className="d-footer-container mobile">
          <div className="ft-left">
            <img
              src={i18n.language === "nl" ? vwcLogo : cytLogo}
              alt="Logo"
              className="logo"
            />
          </div>
          <div className="ft-right mobile">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === "nl"
                  ? "https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                  : "https://checkyourterms.com/en/terms-and-conditions"
              }
            >
              {t("algemeneVoorwaarden")}
              <LaunchIcon style={{ fontSize: "0.8rem", marginLeft: "12px" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === "nl"
                  ? "https://voorwaardenchecker.nl/nl/privacyverklaring"
                  : "https://checkyourterms.com/en/privacy-statement"
              }
            >
              {t("privacyVerklaring")}
              <LaunchIcon style={{ fontSize: "0.8rem", marginLeft: "12px" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://maatwerk.nl/contact.aspx"
            >
              {t("contact")}
            </a>
          </div>
        </div>
      )}

      {/* TABLET */}
      {tablet && (
        <div className="d-footer-container">
          <div className="ft-left">
            <img
              src={i18n.language === "nl" ? vwcLogo : cytLogo}
              alt="Logo"
              className="logo"
            />
          </div>
          <div className="ft-right">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === "nl"
                  ? "https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                  : "https://checkyourterms.com/en/terms-and-conditions"
              }
            >
              {t("algemeneVoorwaarden")}
              <LaunchIcon style={{ fontSize: "0.8rem", marginLeft: "12px" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === "nl"
                  ? "https://voorwaardenchecker.nl/nl/privacyverklaring"
                  : "https://checkyourterms.com/en/privacy-statement"
              }
            >
              {t("privacyVerklaring")}
              <LaunchIcon style={{ fontSize: "0.8rem", marginLeft: "12px" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://maatwerk.nl/contact.aspx"
            >
              {t("contact")}
            </a>
          </div>
        </div>
      )}

      {/* LAPTOP */}
      {laptop && (
        <div className="d-footer-container">
          <div className="ft-left">
            <img
              src={i18n.language === "nl" ? vwcLogo : cytLogo}
              alt="Logo"
              className="logo"
            />
          </div>
          <div className="ft-right">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === "nl"
                  ? "https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                  : "https://checkyourterms.com/en/terms-and-conditions"
              }
            >
              {t("algemeneVoorwaarden")}
              <LaunchIcon style={{ fontSize: "0.8rem", marginLeft: "12px" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === "nl"
                  ? "https://voorwaardenchecker.nl/nl/privacyverklaring"
                  : "https://checkyourterms.com/en/privacy-statement"
              }
            >
              {t("privacyVerklaring")}
              <LaunchIcon style={{ fontSize: "0.8rem", marginLeft: "12px" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://maatwerk.nl/contact.aspx"
            >
              {t("contact")}
            </a>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MaatwerkFooter;
